import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const FLEET_VEHICLE_FIRE_EXTINGUISHER_EDIT_FORM_SCHEMA = yup
  .object()
  .shape({
    name: yup.string().required("Molimo Vas da unesete naziv"),
    // price: yup.string().required("Molimo Vas da unesete cijenu"),
    expirationDate: yup.string().required("Molimo Vas da unesete datum isteka"),
  });
